var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",class:{'mobile': _vm.device == 'mobile'}},[_c('div',{staticClass:"article animation-slide-bottom"},[_c('div',{staticClass:"content text-justify",domProps:{"innerHTML":_vm._s(_vm.articleTypeContent)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }